import React from 'react';
import { BrainIcon, ClockIcon, PenLineIcon, SearchIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, SearchIcon, BrainIcon, PenLineIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-139" data-mp="3m15pdzmfxgpu">
      <div className="mx-auto max-w-5xl" data-id="element-140" data-mp="njjljrfd814z">
        <SectionHeading id="pain-heading" eyebrow="Sound Familiar?" title={<>
              Your Expertise Should Go Into Teaching — <Accent data-id="element-142" data-mp="dsf7qv1fembq">Not Hours of Class Prep.</Accent>
            </>} data-id="element-141" data-mp="nigu9ie4rwoj" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-143" data-mp="8unik8s61eb8">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6" data-id="element-144" data-mp="11irrd361a7i5" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-white" data-id="element-145" data-mp="3bdhqvox57wz5">
                  <Icon className="h-5 w-5 text-brand-violet" strokeWidth={1.5} aria-hidden="true" data-id="element-146" data-mp="3gcua7zot2lwz" />
                </span>
                <span data-id="element-147" data-mp="31memad508zv4">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-148" data-mp="31n6a31sd1tau">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-149" data-mp="2slourlms1vn7">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-150" data-mp="2iplxat2vel6l">
          What if the structure was <Accent data-id="element-151" data-mp="gxgz4zus2rnf">already built for you?</Accent>
        </p>
      </div>
    </section>;
}